// extracted by mini-css-extract-plugin
module.exports = {"root":"index_root__2JftG","menuWrapper":"index_menuWrapper__gaPwC","menuButton":"index_menuButton__Cmnp1","closed":"index_closed__58Sr4","triangle":"index_triangle__3HZIp"};